export default __webpack_public_path__ + "static/bgVestibular-61ae65b4c39d5859720c09410f88235d.png";